function compressImage(
  file,
  { maxWidth = 1024, maxHeight = 1024, quality = 0.7 } = {}
) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      let { width, height } = img;
      const scale = Math.min(maxWidth / width, maxHeight / height, 1);
      width = width * scale;
      height = height * scale;

      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, width, height);

      canvas.toBlob(
        (blob) => {
          if (!blob) return reject(new Error("Compression failed"));
          resolve(blob);
        },
        "image/jpeg",
        quality // 0–1, lower = smaller file
      );
    };
    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
}

export async function fileToBase64(file, opts) {
  if (!file) return null;
  const compressed = await compressImage(file, opts); // compress first
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(compressed);
  });
}

export default fileToBase64;
